import MultiFilter from "@wielink/datatables/Plugins/MultiFilter";
import ClickableRow from "@wielink/datatables/Plugins/ClickableRow";
import RowReorder from "@wielink/datatables/Plugins/RowReorder";

export default [
	MultiFilter,
	ClickableRow,
    RowReorder
];